import React, { useState, useEffect } from 'react';
import { Card, Form } from '@deere/ux.uxframe-react'
import RadioGroup from '../../components/RadioGroup';
import { updateSurveyAnswers } from '../../redux/action/surveyAction';
import { findAnswerIndex, updateAnswerInArray, getTranslation, getAnswerLabel } from '../../utils/utils';
import store from '../../redux/store'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { LABOR_ERR_MSG, EMPTY_BODY, PERCENTAGE_ARRAY, LABOR_SECTION_NAME_INDIRECT } from '../../utils/surveyLiterals'
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';
import { Table as UxTable } from '@deere/ux.uxframe-react';

export default function LaborSegmentationPage({ survey,countries }) {
    const { t } = useTranslation();
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([]);
    const dispatch = useDispatch();
    const [checkSection] = useState(false);
        
    const section = survey.sections.find(e => e.description === LABOR_SECTION_NAME_INDIRECT && e.active);
    const questions = section.questions === undefined ? null : section.questions;
    questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);

    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyResponse])
    
    if (questions === null) { return <div><p>{LABOR_ERR_MSG}</p></div> }

    if(!survey){
        return EMPTY_BODY;
    }

    const updateAnswer = (e, questionId) => {
        updateAnswerInArray(questionId, answers, e.target ? e.target.value : e);
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function updateDate(e, date) {
        updateAnswer(e,date.id);
    }

    function createDependencyTextArea(question) {
        if (question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);  
            if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                return <Form.Row className="d-block mb-4">
                <Form.Group className="mb-4 pl-4">
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <DebounceInput
                        element="textarea"
                        required={!checkSection}
                        className="form-control"
                        onChange={(e) => updateAnswer(e,question.id)}
                        debounceTimeout={300}
                        value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                        name={`${getTranslation(section, 'description')}-${question.id}`}/>
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                    </Form.Group>
                </Form.Row>
            }
        }
        return null;
    }

    function createDependencyDate(question) {
        if(!question)
            return null
        let answerLabel = question ? getAnswerLabel(question, answers) : '-';
        if (question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                return <Form.Row className="d-block mb-4">
                <Form.Group className="mb-4 pl-4">
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <Form.Control type="date" required={!checkSection} id={question.id}
                        data-testid={question.id}
                        defaultValue={answerLabel !== '-' ? answerLabel : ''}
                        onChange={e => updateDate(e,question)}  
                        name={`${getTranslation(section, 'description')}-${question.id}`}/>
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>    
                    </Form.Group>
                </Form.Row>
            }
        }
        return null;
    }

    const createOption = ( question ) => {
        let display = true;
        let index = false;
        if(question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            display = qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString();
            index = display;
        }

        if( display ) {
            return <Form.Row className="d-block mb-4">
                    <Form.Group className={index ? 'mb-4 pl-4' : ''}>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <div><RadioGroup key={4} rgIndex={4} radioLabels={question ? question.selections : []}
                            updateAnswer={updateAnswer} question={question}
                            defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                            section={getTranslation(section, 'description')}
                            checkedProprietary={checkSection}/></div>
                    </Form.Group>
                </Form.Row>
        }
    }

    const createSelect = ( question, options ) => {
        return <Form.Row className="d-block mb-4">
            <Form.Group>
                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                <Form.Control as='select' required={!checkSection} className="custom-select" onChange={(e) => updateAnswer(e, question.id)}
                    value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                    name={getTranslation(section, 'description')+'-'+question.id}>
                    <option value=''>{t('lbl_dropdown_select')}</option>
                    {options ? options.map((opt,indx) => <option key={indx} value={opt}>{opt} %</option>) : null}
                </Form.Control>
                <div className="invalid-feedback">
                    {t('bs_required')}
                </div>
            </Form.Group>
        </Form.Row>
    }

    const createCountrySelect = ( question, options ) => {
        let display = true;
        let index = false;
        if(question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            display = qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString();
            index = display;
        }
        if( display ) {
            return <Form.Row className="d-block mb-4">
                <Form.Group className={index ? 'mb-4 pl-4' : ''}>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <Form.Control as='select' required={!checkSection} className="custom-select" onChange={(e) => updateAnswer(e, question.id)}
                        value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                        name={getTranslation(section, 'description')+'-'+question.id}>
                        <option value=''>{t('lbl_dropdown_select')}</option>
                        {options ? options.map((opt,indx) => <option key={indx} value={opt.iso2CountryCode}>{opt.name}</option>) : null}
                    </Form.Control>
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                </Form.Group>
            </Form.Row>
        }
    }

    const createTableSect = ( question, options ) => {
        return <div>
            <Form.Group>
                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
            </Form.Group>
            <UxTable size="sm" borderless>
                <tbody>
                    <tr>
                        {
                            question.dependentQuestions.map((q, index) => {
                                return <td key={index}>
                                    <Form.Group>
                                        <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                                        <Form.Control required={!checkSection} as='select' onChange={(e) => updateAnswer(e, q.id)} className="custom-select" data-testid={q.id}
                                            value={findAnswerIndex(q.id, answers) >= 0 ? answers[findAnswerIndex(q.id, answers)].answer : ''}
                                            name={getTranslation(section, 'description')+'-'+q.id}>
                                            <option value=''>{t('lbl_dropdown_select')}</option>
                                            {options ? options.map((opt,indx) => <option key={indx} value={opt}>{opt} %</option>) : null}
                                        </Form.Control>
                                        <div className="invalid-feedback">
                                            {t('bs_required')}
                                        </div>
                                    </Form.Group>
                                </td>
                            })
                        }
                    </tr>
                </tbody>
            </UxTable>
        </div>
    }
    

    if (survey === null) { return <></> }
    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}
                </Card.Title>
                {
                    questions.map(question => {
                       if(question.type === 'OPTION') {
                         return createOption(question);
                       }

                       if(question.type === 'SECT') {
                         return createSelect(question, PERCENTAGE_ARRAY);
                       }

                       if(question.type === 'TABLE_SECT') {
                        return createTableSect(question, PERCENTAGE_ARRAY);
                       }

                       if(question.type === 'OPEN') {
                        return createDependencyTextArea(question);
                       }

                       if(question.type === 'DATE') {
                        return createDependencyDate(question);
                       }
                       if(question.type === 'OPTION_CTY') {
                        return createCountrySelect(question,countries);
                       }
                       return <></>
                    })
                }
            </Card.Body>
        </Card>
    </>)
}
